module.exports = __webpack_public_path__ + "media/cards/visa-5228b4ae.png";